import React from "react";

const BridalWhat = () => {
  return (
    <div className="nailExtensionMaintain">
      <h5>What to Expect from SCENT's Bridal Makeup Artists in Bangalore</h5>
      <p>
        When you book a session with our Bridal Makeup Artists in Bangalore, you
        can expect a comprehensive and luxurious experience designed to make you
        look and feel your best. Here’s what the process entails:
      </p>
      <ul>
        <li>
          <h6>1. Initial Consultation</h6>Your journey with SCENT's Bridal
          Makeup Artists in Bangalore begins with an initial consultation.
          During this session, we discuss your vision, preferences, and any
          specific requirements you may have. We also review your skin type and
          any potential sensitivities to ensure we use the right products.
        </li>
        <li>
          <h6>2. Trial Makeup Session</h6>A trial makeup session is an essential
          part of our service. It allows you to see the final look and make any
          adjustments before the big day. Our Bridal Makeup Artists in Bangalore
          will create the look you envision, making sure it complements your
          bridal attire and overall theme.
        </li>
        <li>
          <h6>3. Wedding Day Preparation </h6>On your wedding day, our Bridal
          Makeup Artists in Bangalore will arrive at your location to provide a
          stress-free and seamless makeup application. They will ensure that
          every detail is perfect, from the base to the finishing touches.
        </li>
        <li>
          <h6>4. Final Touch-Ups</h6>
          To keep you looking fresh and flawless, our Bridal Makeup Artists in
          Bangalore offer final touch-ups throughout the day. This ensures your
          makeup stays intact during the ceremony, photoshoot, and reception.
        </li>
      </ul>
    </div>
  );
};

export default BridalWhat;
